import React, { Fragment } from "react";
import { Field } from "redux-form";
import { times } from "lodash";
import { LongStringField } from "cxa-form-field";
import { renderField, RadioButtonGroupRow, renderFieldWithLabel } from "../components";
import ParentSiblingsTable from "./ParentSiblingsTable";

const optionsYesNo = ["Yes", "No"];
const columnsPrefix = ["Emp", "Dep1", "Dep2", "Dep3", "Dep4"];

const HealthQuestions = () => (
  <Fragment>
    <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "fixed" }}>
      <tbody>
        <tr>
          <td rowSpan={2} style={{ borderBottom: "1px solid #000", paddingLeft: 0, width: "50%",wordWrap:"break-word" }}>
            <span style={{ fontWeight: "bold" }}>(C) HEALTH QUESTIONS</span>
            <div style={{ color: "red" }} className="printcontrol">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Note: Any alteration in this form must be
              signed.)
            </div>
          </td>
          <td
            style={{
              border: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Employee
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 1
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 2
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 3
          </td>
          <td
            style={{
              borderTop: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
              fontWeight: "bold",
              textAlign: "center",
            }}
            colSpan={2}
          >
            Dependant 4
          </td>
        </tr>
        <tr>
          {times(5, count => (
            <Fragment key={count}>
              <td
                style={{
                  borderLeft: "1px solid #000",
                  borderBottom: "1px solid #000",
                  textAlign: "center",
                }}
              >
                Yes
              </td>
              <td
                style={{
                  borderRight: "1px solid #000",
                  borderBottom: "1px solid #000",
                  textAlign: "center",
                }}
              >
                No
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            1. Have you ever had or been told to have or been treated for:
          </td>
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
          <td colSpan={2} style={{ borderRight: "1px solid #000" }} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="a. epilepsy / fits, stroke, paralysis / weakness of limb, prolonged headache, nervous breakdown, depression or any other nervous / mental disorders?"
          questionId="MentalDisorders"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="b. ear discharge, nose bleeds, double vision, impaired sight, hearing, or speech or any other disorders of ear, eye, nose and throat?"
          questionId="HearingAndSight"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="c. asthma, bronchitis, persistent cough, coughing with blood, pneumonia, tuberculosis, breathing complaints / discomfort or any other lung disorders?"
          questionId="LungDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="d. raised cholestrol, high blood pressure, heart attack, mitral valve prolapse or other heart valve disorders, breathlessness, irregular heart rate, chest pain, or any disease or disorders of the heart or blood vessels?"
          questionId="HeartDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="e. diabetes mellitus, thyroid disorders or any endocrine disorders?"
          questionId="EndocrineDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="f. gastritis, stomach or duodenal ulcer, blood in stools, fistula, piles or any other stomach or bowel disorder?"
          questionId="BowelDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="g. jaundice, hepatitis B carrier or any form of hepatitis, liver or gallbladder disorders?"
          questionId="GallbladderDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="h. blood, protein or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder or genital organs?"
          questionId="KidneyDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="i. cancer, tumour, cyst or growth of any kind?"
          questionId="Cancer"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="j. slipped disc, gout, arthritis, pain or deformity or disorders of the muscles, spine, limbs or joints or severe injury?"
          questionId="PhysicalInjury"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="k. any sexually transmitted disease or have received any medical advice or counselling for AIDS related conditions (including HIV positive)?"
          questionId="SexualDisease"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="l. endometriosis, fibroids, breast and/or ovarian cysts/lumps/tumours, abnormal pap smear, irregular or painful menstruation or any other gynaecological disorders?"
          questionId="FemaleDisease"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="m. anaemia, haemophilia or any disorders of the blood or any other congenital or hereditary disorders not listed above?"
          questionId="BloodDisorder"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc={
            <div>
              <div>
                n. Other than the conditions listed above, have you had any other health condition
                which led to:
              </div>
              <div>&nbsp;&nbsp;&nbsp;&nbsp;- more than 10 consecutive days off work</div>
            </div>
          }
          questionId="OtherDisorder1"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc={
            <div>&nbsp;&nbsp;&nbsp;&nbsp;- more than 5 consecutive days of hospital admission</div>
          }
          questionId="OtherDisorder2"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc={
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;- follow up consultations or treatment lasting more than a
              month
            </div>
          }
          questionId="OtherDisorder3"
          options={optionsYesNo}
          columns={columnsPrefix}
        />
        <RadioButtonGroupRow
          questionDesc="2. Have you smoked cigarettes in the last 12 months?"
          questionId="Smoke"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 20,
              borderRight: "1px solid #000",
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td>
                    {
                      "If 'Yes', please state number of sticks smoked per day and the number of years."
                    }
                  </td>
                  <td style={{ width: 170 }}>
                    <table
                      className="normalPadded"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            No. of sticks/day
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            No. of years
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {columnsPrefix.map(prefix => (
            <td
              key={prefix}
              style={{
                textAlign: "center",
                borderRight: "1px solid #000",
                borderBottom: "1px solid #000",
              }}
              colSpan={2}
            >
              <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <Field
                        name={`${prefix}SmokeQuantity`}
                        type="text"
                        component={renderField}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name={`${prefix}SmokeNoOfYears`}
                        type="text"
                        component={renderField}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          ))}
        </tr>
        <RadioButtonGroupRow
          questionDesc="3. Do you consume alcohol?"
          questionId="ConsumeAlcohol"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 20,
              borderRight: "1px solid #000",
              borderLeft: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td>{"If 'Yes', please state the type, quantity and frequency."}</td>
                  <td style={{ width: 170 }}>
                    <table
                      className="normalPadded"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Type
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Quantity
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                              fontWeight: "bold",
                            }}
                          >
                            Frequency (per week)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          {columnsPrefix.map(prefix => (
            <td
              key={prefix}
              style={{
                textAlign: "center",
                borderRight: "1px solid #000",
                borderBottom: "1px solid #000",
              }}
              colSpan={2}
            >
              <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <Field
                        name={`${prefix}AlcoholType`}
                        type="text"
                        component={renderField}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name={`${prefix}AlcoholQuantity`}
                        type="text"
                        component={renderField}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Field
                        name={`${prefix}AlcoholFrequencyPerWeek`}
                        type="text"
                        component={renderField}
                        style={{ width: 50 }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          ))}
        </tr>
        <RadioButtonGroupRow
          questionDesc="4. Have you ever been treated for drug or alcohol addiction?"
          questionId="DrugAddiction"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <RadioButtonGroupRow
          questionDesc={
            <div>
              5. Have you had
              <div>&nbsp;&nbsp;- any biopsy, CT scans, or</div>
              <div>
                &nbsp;&nbsp;- any abnormal or pending investigations, scans, blood or urine tests?
              </div>
            </div>
          }
          questionId="AbnormalTest"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {
                  "If 'Yes', please provide below details such as reason, date and results of test done and the diagnosis"
                }
              </div>
              <Field
                name="AbnormalTestReason"
                label="Reason:&nbsp;"
                type="text"
                component={renderFieldWithLabel}
              />
              <Field
                name="AbnormalTestDate"
                label="Date:&nbsp;"
                type="text"
                component={renderFieldWithLabel}
              />
              <Field
                name="AbnormalTestType"
                label="Type of test(s):&nbsp;"
                type="text"
                component={renderFieldWithLabel}
              />
              <Field
                name="AbnormalTestResult"
                label="Result:&nbsp;"
                type="text"
                component={renderFieldWithLabel}
              />
            </div>
          </td>
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="6. Have you ever been accepted at special terms or rates, deferred or declined for any application, renewal, or reinstatement of life, accident, health disability or other insurance policy?"
          questionId="SpecialTerms"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {
                  "If 'Yes', please provide details on date of application and reason for special terms."
                }
              </div>
              <LongStringField
                name="SpecialTermsDetails"
                id="SpecialTermsDetails"
                rows={6}
                cols={20}
              />
            </div>
          </td>
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="7. Do you engage or have any intention of engaging in hazardous activity or occupation such as private flying, scuba diving, motor racing, mountaineering etc?"
          questionId="HazardousActivity"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div style={{ paddingLeft: 15 }}>
              <div>
                {"If 'Yes', please state details such as locations, frequency, depth, etc."}
              </div>
              <LongStringField
                name="HazardousActivityDetails"
                id="HazardousActivityDetails"
                rows={6}
                cols={20}
              />
            </div>
          </td>
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
          <td style={{ borderRight: "1px solid #000" }} colSpan={2} />
        </tr>
        <RadioButtonGroupRow
          questionDesc="8. Have any of your natural parents or siblings died or suffered from (a) heart disease, (b) high blood pressure, (c) stroke, (d) diabetes, (e) cancer, (f) kidney disease, (g) mental disorder, (h) muscular disorder, or any other hereditary disease?"
          questionId="GeneticMedicalCondition"
          options={optionsYesNo}
          columns={columnsPrefix}
          style={{ borderTop: "1px solid #000" }}
        />
        <tr>
          <td
            style={{
              paddingLeft: 30,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <div>
              {
                "If 'Yes', please state relationship, condition, age at onset of condition and age at death (if deceased)."
              }
            </div>
          </td>
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
          <td style={{ paddingLeft: 30, borderBottom: "1px solid #000" }} />
          <td
            style={{
              paddingLeft: 30,
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          />
        </tr>
        <tr>
          <td
            style={{
              paddingLeft: 3,
              borderLeft: "1px solid #000",
              borderRight: "1px solid #000",
              borderBottom: "1px solid #000",
            }}
          >
            <ParentSiblingsTable idArray={[1, 2]} />
          </td>
          <td
            colSpan={10}
            style={{
              borderBottom: "1px solid #000",
              borderRight: "1px solid #000",
            }}
          >
            <ParentSiblingsTable idArray={[3, 4]} />
          </td>
        </tr>
        <tr>
          <td colSpan={11} style={{ paddingLeft: 0, paddingRight: 0 }}>
            If any of the answers to Question 1 is YES, please PROVIDE COMPLETE INFORMATION and
            MEDICAL REPORT. If necessary, please attach a separate sheet.
            <br />
            <table style={{ borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    Name
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    Sub-Qn.
                    <br />
                    (Eg. a,b)
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    Medical
                    <br />
                    Condition
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    Date of
                    <br />
                    Diagnosis
                  </td>
                  <td
                    colSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Treatment
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    Name & Address of
                    <br />
                    Doctor / Hospital
                  </td>
                  <td rowSpan={2} style={{ border: "1px solid #000", textAlign: "left" }}>
                    Current medical status
                    <br />
                    (eg. fully recovered, follow up
                    <br />
                    treatment/investigation
                    <br />
                    required?)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Date
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      textAlign: "center",
                    }}
                  >
                    Duration
                  </td>
                </tr>
                {times(4, count => {
                  const id = count + 1;
                  return (
                    <tr key={id}>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoName${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: 150 }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoSubQNo${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: 30 }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoMedicalCondition${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoDiagnosisDate${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoTreatmentDate${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoTreatmentDuration${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoMedicalProvider${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                      <td style={{ border: "1px solid #000", textAlign: "center" }}>
                        <Field
                          name={`MoreInfoMedicalStatus${id}`}
                          type="text"
                          component={renderField}
                          style={{ width: "100%" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </Fragment>
);

export default HealthQuestions;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/SINGLIFEHD202202/HealthQuestions.js